import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { environment } from '../../environments/environment';
import { ClaimsService } from '../services/claims.service';
import { StateService } from '../services/state.service';
import { map, catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

export class ValidGuidGuard {
    constructor(
        private claimsService: ClaimsService,
        private router: Router,
        private stateService: StateService
    ) { }

    canActivate(
        route: ActivatedRouteSnapshot
    ): Observable<boolean | UrlTree> {
        const guid = route.params['guid']?.toUpperCase();
        this.stateService.guid = guid;

        if (guid === environment.defaultGuid && this.isLoginPage()) {
            this.setSigningUpFlag(false); 
            return of(this.router.createUrlTree([environment.defaultGuid, 'landing']));
        }

        if (!this.isValidGuid(guid)) {
            this.setSigningUpFlag(false); 
            return of(this.router.createUrlTree([environment.defaultGuid, 'invalid']));
        }

        return this.claimsService.validateGuid(guid).pipe(
            map(result => {
                if (result) {
                    if (result.recordExists && !result.hasExpired && result.claimReference && result.isActive) {
                        this.stateService.guid = guid;
                        this.stateService.claimRef = result.claimReference;
                        this.stateService.isFirstSignIn = result.isRegistered ?? false ? false : true;
                        return true;
                    }
                    else if (result.recordExists && result.hasExpired && result.isActive) {
                        this.setSigningUpFlag(false);
                        console.warn('GUID expired for:', guid);
                        return this.router.createUrlTree([guid, 'expired']);
                    }
                    else if (result.recordExists && !result.isActive) {
                        this.setSigningUpFlag(false);
                        console.warn('Account closed:', guid);
                        return this.router.createUrlTree([guid, 'closed']);
                    }
                    else {
                        this.setSigningUpFlag(false);
                        console.warn('GUID validation failed for:', guid);
                        return this.router.createUrlTree([guid, 'invalid']);
                    }
                }
                else {
                    this.setSigningUpFlag(false);
                    console.error('Error: Received invalid result from validateGuid for:', guid);
                    return this.router.createUrlTree([guid, 'invalid']);
                }
            }),
            catchError(err => {
                this.setSigningUpFlag(false);
                console.error('Error validating GUID:', err);
                this.router.navigate(['/error'], {
                    queryParams: {
                        headerText: 'Error',
                        contentText: err
                    }
                });
                return of(false);
            })
        );
    }

    private isValidGuid(guid: string | null | undefined): boolean {
        const guidRegex = /^(?:\{{0,1}(?:[0-9a-fA-F]){8}-(?:[0-9a-fA-F]){4}-(?:[0-9a-fA-F]){4}-(?:[0-9a-fA-F]){4}-(?:[0-9a-fA-F]){12}\}{0,1})$/;
        return guid !== null && guid !== undefined && guidRegex.test(guid);
    }

    private setSigningUpFlag(isSigningUp: boolean) {
        this.stateService.isSigningUp = isSigningUp;
        localStorage.setItem('signingUp', JSON.stringify(isSigningUp));
    }

    private isLoginPage(): boolean {
        const currentUrl = this.router.url; 
        return currentUrl.includes('login');
    }
}